import { render, staticRenderFns } from "./highest-score-report.vue?vue&type=template&id=7353061e"
import script from "./highest-score-report.vue?vue&type=script&lang=js"
export * from "./highest-score-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports